/* eslint-disable */
const getters = {
  getTaxes(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
